// Email Templates for various workflows
// This utility provides pre-formatted email bodies for different document request scenarios

export const emailTemplates = {
  // --- 1. REQUEST DETAILS TEMPLATES ---
  cvitpRequestDetails: {
    subject: 'CVITP Tax Clinic - Required Documents Checklist',
    bodyTemplate: (uploadLink) => `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6; max-width: 600px;">
        <p>Thank you for reaching out to us regarding the filing of your income tax return. We're here to help you every step of the way.</p>

        <p>In order to proceed, we will need some essential information and documents for each year from you to ensure your tax return is accurate and complete.</p>

        <p>Here's what we need:</p>

        <p><strong>📝 Personal Information:</strong><br>
        1. First Name<br>
        2. Middle Name<br>
        3. Last Name<br>
        4. SIN Number<br>
        5. Date of Birth (DD/MM/YYYY)<br>
        6. Status in Canada (Permanent Resident / Citizen)<br>
        7. Gender (Male / Female / Other)</p>

        <p><strong>🏠 Address & Contact Details:</strong><br>
        8. Door or Apt No.<br>
        9. Street Address<br>
        10. City<br>
        11. Postal Code<br>
        12. Phone Number<br>
        13. Email Address</p>

        <p><strong>📄 Financial/Immigration Details:</strong><br>
        14. Total Rent Paid for each Year<br>
        15. Did you immigrate to Canada? (Yes/No)<br>
        16. If yes, Date of Entry into Canada</p>

        <p><strong>📑 Tax Slips & Marital/Family Info:</strong><br>
        17. All relevant tax slips (T4, T5007, T4A, T2202, etc.)<br>
        18. Marital Status (Single / Married / Separated / Widowed / Divorced)<br>
        19. If married – spouse's details (same as questions #1–18)<br>
        20. If you have children under 18 – full names, DOBs, gender</p>

        <p>Please feel free to send all the necessary information and documents via the secure document upload portal below or in a single email to <a href="mailto:cvitp-team@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">cvitp-team@orientalbiz.ca</a>.</p>

        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width: 400px; border: 1px solid #e1e1e1; border-radius: 8px; font-family: Arial, sans-serif; margin-top: 20px; margin-bottom: 20px;">
          <tr>
            <td>
              <a href="${uploadLink}" style="text-decoration: none; color: inherit; display: block;">
                <div style="padding: 15px; background-color: #f9f9f9; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
                  <h3 style="margin: 0 0 5px 0; font-size: 16px; color: #333333;">📤 Secure Document Upload</h3>
                  <p style="margin: 0; font-size: 14px; color: #666666;">Click here to securely upload your documents to Orientalbiz.</p>
                </div>
              </a>
            </td>
          </tr>
        </table>

        <p>Providing complete and accurate information will help ensure your tax returns are prepared correctly and efficiently.</p>

        <p>If you have any trouble gathering the documents or need any assistance, please let us know.<br>
        We are here to make this process as smooth as possible for you.</p>

        <p>Thank you for choosing Oriental Business Solutions!</p>

        <p>Best regards,<br>
        <strong>CVITP Tax Clinic Team</strong><br>
        Oriental Business Solutions Inc.<br>
        📧 <a href="mailto:cvitp-team@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">cvitp-team@orientalbiz.ca</a><br>
        Tel: <a href="tel:+16478475477" style="color: #0056b3; text-decoration: none;">+1 (647) 847-5477</a><br>
        Available: Mon - Fri 9AM to 6PM</p>
    </div>`
  },

  personalRequestDetails: {
    subject: 'Personal Tax Return - Required Documents',
    bodyTemplate: (uploadLink) => `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6; max-width: 600px;">
        <p>Thank you for choosing Oriental Business Solutions for your personal tax filing needs.</p>
        <p>To prepare your personal tax return accurately, we require the following documents and information:</p>
        <p><strong>📑 Tax Slips & Documents:</strong><br>
        1. Notice of Assessment from previous year<br>
        2. T4 slips (Employment Income)<br>
        3. T5 slips (Investment Income)<br>
        4. T4A slips (Other Income)<br>
        5. Receipts for deductible expenses<br>
        6. Mortgage interest statements<br>
        7. Property tax documents<br>
        8. Charitable donation receipts</p>

        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width: 400px; border: 1px solid #e1e1e1; border-radius: 8px; font-family: Arial, sans-serif; margin-top: 20px; margin-bottom: 20px;">
          <tr>
            <td>
              <a href="${uploadLink}" style="text-decoration: none; color: inherit; display: block;">
                <div style="padding: 15px; background-color: #f9f9f9; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
                  <h3 style="margin: 0 0 5px 0; font-size: 16px; color: #333333;">📤 Secure Document Upload</h3>
                  <p style="margin: 0; font-size: 14px; color: #666666;">Click here to securely upload your documents to Orientalbiz.</p>
                </div>
              </a>
            </td>
          </tr>
        </table>
        <p>Or email them to: <a href="mailto:info@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">info@orientalbiz.ca</a></p>
        <p>Best regards,<br>
        <strong>Personal Tax Expert Team</strong><br>
        Oriental Business Solutions Inc.<br>
        📧 <a href="mailto:info@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">info@orientalbiz.ca</a><br>
        Tel: <a href="tel:+16478556177" style="color: #0056b3; text-decoration: none;">+1 (647) 855-6177</a></p>
    </div>`
  },

  corporateRequestDetails: {
    subject: 'Corporate Tax Return - Required Documents',
    bodyTemplate: (uploadLink) => `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6; max-width: 600px;">
        <p>Thank you for entrusting Oriental Business Solutions with your corporate tax filing.</p>
        <p>To prepare your corporate tax return, we will need the following:</p>
        <p><strong>📑 Financial Documents:</strong><br>
        1. Financial Statements (Balance Sheet & Income Statement)<br>
        2. General Ledger<br>
        3. Bank Statements & Reconciliations<br>
        4. Invoices & Receipts<br>
        5. T4 and T4A Slips for Employees<br>
        6. T5 Slips (if applicable)<br>
        7. Previous Year's Tax Return<br>
        8. Corporate Registration Documents</p>

        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width: 400px; border: 1px solid #e1e1e1; border-radius: 8px; font-family: Arial, sans-serif; margin-top: 20px; margin-bottom: 20px;">
          <tr>
            <td>
              <a href="${uploadLink}" style="text-decoration: none; color: inherit; display: block;">
                <div style="padding: 15px; background-color: #f9f9f9; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
                  <h3 style="margin: 0 0 5px 0; font-size: 16px; color: #333333;">📤 Secure Document Upload</h3>
                  <p style="margin: 0; font-size: 14px; color: #666666;">Click here to securely upload your documents to Orientalbiz.</p>
                </div>
              </a>
            </td>
          </tr>
        </table>
        <p>Or contact us at: <a href="mailto:info@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">info@orientalbiz.ca</a></p>
        <p>We look forward to assisting you.<br><br>
        Best regards,<br>
        <strong>Corporate Tax Expert Team</strong><br>
        Oriental Business Solutions Inc.<br>
        📧 <a href="mailto:info@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">info@orientalbiz.ca</a><br>
        Tel: <a href="tel:+16478556177" style="color: #0056b3; text-decoration: none;">+1 (647) 855-6177</a></p>
    </div>`
  },

  // --- 2. REQUEST ESIGN TEMPLATES ---
  cvitpRequestEsign: {
    subject: `Action Required: Review & Sign Your Tax Return Draft`,
    bodyTemplate: (generatedLink, taxYear, clientName) => `
        <div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6;">
          <p>Hello ${clientName},</p>
          <p>Our team has completed the draft for your <strong>${taxYear}</strong> tax return.</p>
          <p>Please use our secure client portal link below to review the draft, supply your authorization signature:</p>
          <div style="margin: 20px 0;">
            <a href="${generatedLink}" style="display: inline-block; padding: 12px 24px; background-color: #198754; color: #ffffff; text-decoration: none; border-radius: 5px; font-weight: bold;">Review &amp; Sign Tax Return</a>
          </div>
          <p style="font-size: 10px;">If the button doesn't work, you can copy and paste the following link into your browser:
          <a href="${generatedLink}" style="color: #0d6efd; text-decoration: none;">${generatedLink}</a></p>
        <p>Best regards,<br>
        <strong>CVITP Tax Clinic Team</strong><br>
        Oriental Business Solutions Inc.<br>
        📧 <a href="mailto:cvitp-team@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">cvitp-team@orientalbiz.ca</a><br>
        Tel: <a href="tel:+16478475477" style="color: #0056b3; text-decoration: none;">+1 (647) 847-5477</a><br>
        Available: Mon - Fri 9AM to 6PM</p>
        </div>
      `
  },

  personalRequestEsign: {
    subject: `Action Required: Review & Sign Your Personal Tax Return Draft`,
    bodyTemplate: (generatedLink, taxYear, clientName) => `
        <div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6;">
          <p>Hello ${clientName},</p>
          <p>Our team has completed the draft for your <strong>${taxYear}</strong> personal tax return.</p>
          <p>Please use our secure client portal link below to review the draft and supply your authorization signature:</p>
          <div style="margin: 20px 0;">
            <a href="${generatedLink}" style="display: inline-block; padding: 12px 24px; background-color: #198754; color: #ffffff; text-decoration: none; border-radius: 5px; font-weight: bold;">Review &amp; Sign Tax Return</a>
          </div>
          <p style="font-size: 10px;">If the button doesn't work, you can copy and paste the following link into your browser:
          <a href="${generatedLink}" style="color: #0d6efd; text-decoration: none;">${generatedLink}</a></p>
        <p>Best regards,<br>
        <strong>Personal Tax Expert Team</strong><br>
        Oriental Business Solutions Inc.<br>
        📧 <a href="mailto:info@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">info@orientalbiz.ca</a><br>
        Tel: <a href="tel:+16478556177" style="color: #0056b3; text-decoration: none;">+1 (647) 855-6177</a></p>
        </div>
      `
  },

  corporateRequestEsign: {
    subject: `Action Required: Review & Sign Your Corporate Tax Return Draft`,
    bodyTemplate: (generatedLink, taxYear, clientName) => `
        <div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6;">
          <p>Hello ${clientName},</p>
          <p>Our team has completed the draft for your <strong>${taxYear}</strong> corporate tax return.</p>
          <p>Please use our secure client portal link below to review the draft and supply your authorization signature:</p>
          <div style="margin: 20px 0;">
            <a href="${generatedLink}" style="display: inline-block; padding: 12px 24px; background-color: #198754; color: #ffffff; text-decoration: none; border-radius: 5px; font-weight: bold;">Review &amp; Sign Tax Return</a>
          </div>
          <p style="font-size: 10px;">If the button doesn't work, you can copy and paste the following link into your browser:
          <a href="${generatedLink}" style="color: #0d6efd; text-decoration: none;">${generatedLink}</a></p>
        <p>Best regards,<br>
        <strong>Corporate Tax Expert Team</strong><br>
        Oriental Business Solutions Inc.<br>
        📧 <a href="mailto:info@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">info@orientalbiz.ca</a><br>
        Tel: <a href="tel:+16478556177" style="color: #0056b3; text-decoration: none;">+1 (647) 855-6177</a></p>
        </div>
      `
  },

  // --- 3. REQUEST DOCUMENT TEMPLATES ---
  cvitpRequestDocument: {
    subject: 'Action Required: Please upload your CVITP Tax documents',
    bodyTemplate: (customerFolderName, uploadLink) => `
        <div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6;">
          <p>Hi ${customerFolderName},</p>
          <p>Please use the following link to securely upload any additional documents for your CVITP tax file:</p>
          <div style="margin: 20px 0;">
            <a href="${uploadLink}" style="display: inline-block; padding: 12px 24px; background-color: #0d6efd; color: #ffffff; text-decoration: none; border-radius: 5px; font-weight: bold;">Securely Upload Documents</a>
          </div>
          <p>If the button doesn't work, you can copy and paste the following link into your browser:</p>
          <p style="word-break: break-all; background-color: #f8f9fa; padding: 12px; border-radius: 4px; border: 1px solid #e9ecef;">
            <a href="${uploadLink}" style="color: #0d6efd; text-decoration: none;">${uploadLink}</a>
          </p>
          <p>Thank you.<br><br>
          Best regards,<br>
          <strong>CVITP Tax Clinic Team</strong><br>
          Oriental Business Solutions Inc.<br>
          📧 <a href="mailto:cvitp-team@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">cvitp-team@orientalbiz.ca</a><br>
          Tel: <a href="tel:+16478475477" style="color: #0056b3; text-decoration: none;">+1 (647) 847-5477</a><br>
          Available: Mon - Fri 9AM to 6PM</p>
        </div>
      `
  },

  personalRequestDocument: {
    subject: 'Action Required: Please upload your Personal Tax documents',
    bodyTemplate: (customerFolderName, uploadLink) => `
        <div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6;">
          <p>Hi ${customerFolderName},</p>
          <p>Please use the following link to securely upload any additional documents for your personal tax file:</p>
          <div style="margin: 20px 0;">
            <a href="${uploadLink}" style="display: inline-block; padding: 12px 24px; background-color: #0d6efd; color: #ffffff; text-decoration: none; border-radius: 5px; font-weight: bold;">Securely Upload Documents</a>
          </div>
          <p>If the button doesn't work, you can copy and paste the following link into your browser:</p>
          <p style="word-break: break-all; background-color: #f8f9fa; padding: 12px; border-radius: 4px; border: 1px solid #e9ecef;">
            <a href="${uploadLink}" style="color: #0d6efd; text-decoration: none;">${uploadLink}</a>
          </p>
          <p>Thank you.<br><br>
          Best regards,<br>
          <strong>Personal Tax Expert Team</strong><br>
          Oriental Business Solutions Inc.<br>
          📧 <a href="mailto:info@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">info@orientalbiz.ca</a><br>
          Tel: <a href="tel:+16478556177" style="color: #0056b3; text-decoration: none;">+1 (647) 855-6177</a></p>
        </div>
      `
  },

  corporateRequestDocument: {
    subject: 'Action Required: Please upload your Corporate Tax documents',
    bodyTemplate: (customerFolderName, uploadLink) => `
        <div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6;">
          <p>Hi ${customerFolderName},</p>
          <p>Please use the following link to securely upload any additional documents for your corporate tax file:</p>
          <div style="margin: 20px 0;">
            <a href="${uploadLink}" style="display: inline-block; padding: 12px 24px; background-color: #0d6efd; color: #ffffff; text-decoration: none; border-radius: 5px; font-weight: bold;">Securely Upload Documents</a>
          </div>
          <p>If the button doesn't work, you can copy and paste the following link into your browser:</p>
          <p style="word-break: break-all; background-color: #f8f9fa; padding: 12px; border-radius: 4px; border: 1px solid #e9ecef;">
            <a href="${uploadLink}" style="color: #0d6efd; text-decoration: none;">${uploadLink}</a>
          </p>
          <p>Thank you.<br><br>
          Best regards,<br>
          <strong>Corporate Tax Expert Team</strong><br>
          Oriental Business Solutions Inc.<br>
          📧 <a href="mailto:info@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">info@orientalbiz.ca</a><br>
          Tel: <a href="tel:+16478556177" style="color: #0056b3; text-decoration: none;">+1 (647) 855-6177</a></p>
        </div>
      `
  },

  faxRequestLink: {
    subject: 'Secure Fax Submission Link from Oriental Business Solutions Inc.',
    bodyTemplate: (generatedLink) => `
                    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; border: 1px solid #e0e0e0; padding: 30px; border-radius: 8px;">
                        <h2 style="color: #1A1A4B; border-bottom: 2px solid #4A6EC9; padding-bottom: 10px;">Secure Fax Submission Link</h2>
                        <p>Hello,</p>
                        <p>Thank you for choosing Oriental Business Solutions Inc. for your secure document transmission needs.</p>
                        <p>As requested, here is your unique and secure link to send your paper applications or documents via fax to the Canada Revenue Agency (CRA) or your desired destination. This link is valid for a <strong>single use</strong>.</p>
                        <div style="text-align: center; margin: 30px 0;">
                            <a href="${generatedLink}" style="background-color: #4A6EC9; color: #ffffff; padding: 15px 25px; text-decoration: none; border-radius: 5px; font-weight: bold; display: inline-block;">Click Here to Send Your Secure Fax</a>
                        </div>
                        <h3 style="color: #1A1A4B; font-size: 16px;">Instructions:</h3>
                        <ol style="padding-left: 20px; color: #555; line-height: 1.6;">
                            <li>Click the secure link above.</li>
                            <li>Fill in the recipient's fax number (e.g., the CRA fax number) and your details on the form.</li>
                            <li>Attach your paper application or documents (PDF format, max 10MB).</li>
                            <li>Click 'Send Secure Fax' to complete the process.</li>
                        </ol>
                        <p>If you have any questions or encounter any issues, please do not hesitate to contact us by replying to this email.</p>
                        <p>Thank you.<br><br>
                        Best regards,<br>
                        <strong>Oriental Business Solutions Inc.</strong><br>
                        📧 <a href="mailto:info@orientalbiz.ca" style="color: #0056b3; text-decoration: none;">info@orientalbiz.ca</a><br>
                        Tel: <a href="tel:+16478556177" style="color: #0056b3; text-decoration: none;">+1 (647) 855-6177</a></p>
                    </div>
                `,
  },

  sendInvoice: {
    subject: 'Invoice from Oriental Business Solutions Inc.',
    bodyTemplate: (invoiceNum, dueDate, totalAmount) => `<div style="background-color: #f9fafb; padding: 40px 20px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #374151; line-height: 1.6;">
          <div style="max-width: 550px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03); border: 1px solid #e5e7eb;">
              
              <!-- Header Banner -->
              <div style="background-color: #2563eb; padding: 35px 30px; text-align: center;">
                  <!-- White Circle with Icon -->
                  <div style="background-color: #ffffff; width: 48px; height: 48px; border-radius: 50%; display: inline-block; line-height: 48px; margin-bottom: 15px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                      <span style="color: #2563eb; font-size: 22px; font-weight: bold;">$</span>
                  </div>
                  <h2 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600; letter-spacing: 0.5px;">Your Invoice is Ready</h2>
              </div>

              <!-- Content Body -->
              <div style="padding: 35px 30px;">
                  <p style="margin-top: 0; font-size: 16px; color: #111827;">Hello,</p>
                  <p style="font-size: 15px; color: #4b5563;">Thank you for choosing Oriental Business Solutions Inc. for your professional accounting and tax needs. Please find the summary of your invoice <strong>#${invoiceNum}</strong> below.</p>
                  
                  <!-- Summary Card Box -->
                  <div style="background-color: #eff6ff; border-left: 4px solid #3b82f6; padding: 20px; margin: 25px 0; border-radius: 0 6px 6px 0;">
                      <table style="width: 100%; border-collapse: collapse;">
                          <tr>
                              <td style="padding: 6px 0; font-size: 14px; color: #4b5563; font-weight: 600; width: 45%;">Invoice Number:</td>
                              <td style="padding: 6px 0; font-size: 14px; color: #111827; font-weight: 700;">#${invoiceNum}</td>
                          </tr>
                          <tr>
                              <td style="padding: 6px 0; font-size: 14px; color: #4b5563; font-weight: 600;">Total Amount Due:</td>
                              <td style="padding: 6px 0; font-size: 16px; color: #16a34a; font-weight: 700;">$${totalAmount} CAD</td>
                          </tr>
                          <tr>
                              <td style="padding: 6px 0; font-size: 14px; color: #4b5563; font-weight: 600;">Due Date:</td>
                              <td style="padding: 6px 0; font-size: 14px; color: #dc2626; font-weight: 700;">${dueDate}</td>
                          </tr>
                      </table>
                  </div>

                  <!-- Attachment Callout -->
                  <p style="font-size: 14px; color: #4b5563; margin-bottom: 25px;">
                      <strong>📎 Attached Document:</strong> An itemized PDF copy of your invoice is attached to this email for your records.
                  </p>

                  <!-- Payment Instructions -->
                  <h3 style="font-size: 16px; color: #111827; margin-top: 30px; margin-bottom: 10px;">How to pay</h3>
                  <p style="font-size: 14px; color: #4b5563; margin-top: 0;">
                      We accept payments via <strong>Interac e-Transfer</strong>. Please send your payment to <a href="mailto:info@orientalbiz.ca" style="color: #2563eb; text-decoration: none; font-weight: 500;">info@orientalbiz.ca</a>. 
                      <br><br>
                      <em>(Auto-deposit is enabled, so no password is required. Please include your Invoice Number in the e-Transfer message).</em>
                  </p>
                  
                  <p style="font-size: 15px; font-weight: 500; color: #111827; margin-top: 30px; margin-bottom: 0;">We appreciate your business!</p>
              </div>

              <!-- Footer -->
              <div style="background-color: #f3f4f6; padding: 25px 30px; border-top: 1px solid #e5e7eb; font-size: 13px; color: #4b5563;">
                  <strong style="font-size: 15px; color: #111827; display: block; margin-bottom: 3px;">Oriental Business Solutions Inc.</strong>
                  <span style="display: block; margin-bottom: 12px; color: #6b7280;">Professional Accounting & Tax Services</span>
                  
                  <!-- Tightly Grouped Contact Info without Tables -->
                  <div style="line-height: 1.8; margin-bottom: 20px;">
                      <strong>Email:</strong> <a href="mailto:info@orientalbiz.ca" style="color: #2563eb; text-decoration: none;">info@orientalbiz.ca</a><br>
                      <strong>Phone:</strong> <a href="tel:+16478556177" style="color: #2563eb; text-decoration: none;">+1 (647) 855-6177</a>
                  </div>
                  
                  <!-- System Disclaimer -->
                  <p style="margin-top: 0; margin-bottom: 0; font-size: 11px; color: #9ca3af; line-height: 1.4; border-top: 1px solid #e5e7eb; padding-top: 15px;">
                      <em>This is an automated message containing your invoice details. If you have any questions regarding your bill, please contact us using the information above.</em>
                  </p>
              </div>

          </div>
      </div>`
  },

  sendConfirmation: {
    subject: 'Confirmation: Your Personal Tax Return has been Filed',
    bodyTemplate: (clientName) => `<div style="background-color: #f9fafb; padding: 40px 20px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #374151; line-height: 1.6;">
          <div style="max-width: 550px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03); border: 1px solid #e5e7eb;">
              
              <!-- Header Banner -->
              <div style="background-color: #10b981; padding: 35px 30px; text-align: center;">
                  <!-- White Checkmark Circle -->
                  <div style="background-color: #ffffff; width: 48px; height: 48px; border-radius: 50%; display: inline-block; line-height: 48px; margin-bottom: 15px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                      <span style="color: #10b981; font-size: 24px; font-weight: bold;">✓</span>
                  </div>
                  <h2 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600; letter-spacing: 0.5px;">Return Successfully Filed</h2>
              </div>

              <!-- Content Body -->
              <div style="padding: 35px 30px;">
                  <p style="margin-top: 0; font-size: 16px; color: #111827;">Dear ${clientName},</p>
                  <p style="font-size: 15px; color: #4b5563;">This email is to confirm that your personal income tax return has been successfully transmitted to the Canada Revenue Agency (CRA).</p>
                  
                  <!-- Attachment Callout Box -->
                  <div style="background-color: #f0fdf4; border-left: 4px solid #16a34a; padding: 15px 20px; margin: 25px 0; border-radius: 0 6px 6px 0;">
                      <p style="margin: 0; font-size: 14px; color: #166534;"><strong>📎 Attached Document</strong><br>
                      Your official filing confirmation and tax summary are attached. <strong>Please save this document</strong> in a secure place for your personal records.</p>
                  </div>

                  <!-- Next Steps -->
                  <h3 style="font-size: 16px; color: #111827; margin-top: 30px; margin-bottom: 10px;">Important Reminders</h3>
                  <ul style="font-size: 14px; color: #4b5563; padding-left: 20px; margin-top: 0;">
                      <li style="margin-bottom: 8px;"><strong>Notice of Assessment:</strong> The CRA typically processes electronic returns within 2 weeks. You will receive your NOA by mail or via your CRA My Account.</li>
                      <li><strong>Balances & Refunds:</strong> If you owe a balance, please ensure it is paid by the CRA deadline to avoid interest. If you are expecting a refund, it will be deposited directly or mailed via cheque by the CRA.</li>
                  </ul>

                  <p style="font-size: 15px; font-weight: 500; color: #111827; margin-top: 30px; margin-bottom: 0;">Thank you for trusting Oriental Business Solutions Inc. with your tax needs!</p>
              </div>

              <!-- Footer -->
              <div style="background-color: #f3f4f6; padding: 30px; border-top: 1px solid #e5e7eb; font-size: 13px; color: #4b5563;">
                  <strong style="font-size: 15px; color: #111827; display: block; margin-bottom: 5px;">Oriental Business Solutions Inc.</strong>
                  <span style="display: block; margin-bottom: 15px; color: #6b7280;">Professional Accounting & Tax Services</span>
                  
                  <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 10px;">
                      <tr>
                          <td style="padding-bottom: 8px;">
                              <strong>Email:</strong> <a href="mailto:info@orientalbiz.ca" style="color: #2563eb; text-decoration: none;">info@orientalbiz.ca</a>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <strong>Phone:</strong> <a href="tel:+16478556177" style="color: #2563eb; text-decoration: none;">+1 (647) 855-6177</a>
                          </td>
                      </tr>
                  </table>
                  
                  <!-- Privacy Disclaimer -->
                  <p style="margin-top: 25px; margin-bottom: 0; font-size: 11px; color: #9ca3af; line-height: 1.5;">
                      <em><strong>Privacy Note:</strong> For your security, please do not reply to this email with sensitive personal information, such as your Social Insurance Number (SIN).</em>
                  </p>
              </div>

          </div>
      </div>`
  },

  corporateFilingConfirmation: {
    subject: 'Confirmation: Your Corporate Filing has been Submitted',
    bodyTemplate: (clientName, filingType) => `<div style="background-color: #f9fafb; padding: 40px 20px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #374151; line-height: 1.6;">
          <div style="max-width: 550px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03); border: 1px solid #e5e7eb;">
              
              <!-- Header Banner (Indigo for Corporate) -->
              <div style="background-color: #4f46e5; padding: 35px 30px; text-align: center;">
                  <!-- White Checkmark Circle -->
                  <div style="background-color: #ffffff; width: 48px; height: 48px; border-radius: 50%; display: inline-block; line-height: 48px; margin-bottom: 15px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                      <span style="color: #4f46e5; font-size: 24px; font-weight: bold;">✓</span>
                  </div>
                  <h2 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600; letter-spacing: 0.5px;">Corporate Filing Successful</h2>
              </div>

              <!-- Content Body -->
              <div style="padding: 35px 30px;">
                  <p style="margin-top: 0; font-size: 16px; color: #111827;">Dear ${clientName},</p>
                  <p style="font-size: 15px; color: #4b5563;">This email is to confirm that your <strong>${filingType}</strong> has been successfully transmitted to the Canada Revenue Agency (CRA).</p>
                  
                  <!-- Attachment Callout Box -->
                  <div style="background-color: #eef2ff; border-left: 4px solid #4338ca; padding: 15px 20px; margin: 25px 0; border-radius: 0 6px 6px 0;">
                      <p style="margin: 0; font-size: 14px; color: #3730a3;"><strong>📎 Attached Documentation</strong><br>
                      A copy of your submission and the official CRA confirmation receipt are attached. <strong>Please retain these documents</strong> for your corporate records.</p>
                  </div>

                  <!-- Next Steps -->
                  <h3 style="font-size: 16px; color: #111827; margin-top: 30px; margin-bottom: 10px;">Next Steps</h3>
                  <ul style="font-size: 14px; color: #4b5563; padding-left: 20px; margin-top: 0;">
                      <li style="margin-bottom: 8px;"><strong>Payments:</strong> If there is a balance owing associated with this filing, please ensure it is remitted to the CRA directly through your business bank account prior to the deadline to avoid penalties and interest.</li>
                      <li><strong>Record Keeping:</strong> The CRA requires businesses to keep all supporting documents and records for a minimum of 6 years.</li>
                  </ul>

                  <p style="font-size: 15px; font-weight: 500; color: #111827; margin-top: 30px; margin-bottom: 0;">Thank you for continuing to partner with us for your corporate accounting needs.</p>
              </div>

              <!-- Footer -->
              <div style="background-color: #f3f4f6; padding: 30px; border-top: 1px solid #e5e7eb; font-size: 13px; color: #4b5563;">
                  <strong style="font-size: 15px; color: #111827; display: block; margin-bottom: 5px;">Oriental Business Solutions Inc.</strong>
                  <span style="display: block; margin-bottom: 15px; color: #6b7280;">Professional Accounting & Tax Services</span>
                  
                  <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 10px;">
                      <tr>
                          <td style="padding-bottom: 8px;">
                              <strong>Email:</strong> <a href="mailto:info@orientalbiz.ca" style="color: #2563eb; text-decoration: none;">info@orientalbiz.ca</a>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <strong>Phone:</strong> <a href="tel:+16478556177" style="color: #2563eb; text-decoration: none;">+1 (647) 855-6177</a>
                          </td>
                      </tr>
                  </table>
                  
                  <!-- Privacy Disclaimer -->
                  <p style="margin-top: 25px; margin-bottom: 0; font-size: 11px; color: #9ca3af; line-height: 1.5;">
                      <em><strong>Confidentiality Notice:</strong> This email and any attachments are confidential and intended solely for the use of the individual or entity to whom they are addressed.</em>
                  </p>
              </div>

          </div>
      </div>`
  },

  cvitpSendConfirmation: {
    subject: 'Confirmation: Your Tax Return has been filed with the CRA',
    bodyTemplate: (clientName) => `<div style="background-color: #f9fafb; padding: 40px 20px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #374151; line-height: 1.6;">
      <div style="max-width: 550px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03); border: 1px solid #e5e7eb;">
          
          <!-- Header Banner -->
          <div style="background-color: #10b981; padding: 35px 30px; text-align: center;">
              <!-- White Checkmark Circle -->
              <div style="background-color: #ffffff; width: 48px; height: 48px; border-radius: 50%; display: inline-block; line-height: 48px; margin-bottom: 15px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                  <span style="color: #10b981; font-size: 24px; font-weight: bold;">✓</span>
              </div>
              <h2 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600; letter-spacing: 0.5px;">Return Successfully Filed</h2>
          </div>

          <!-- Content Body -->
          <div style="padding: 35px 30px;">
              <p style="margin-top: 0; font-size: 16px; color: #111827;">Dear ${clientName},</p>
              <p style="font-size: 15px; color: #4b5563;">Great news! This email confirms that your tax return has been successfully transmitted to the Canada Revenue Agency (CRA) through the Community Volunteer Income Tax Program (CVITP).</p>
              
              <!-- Attachment Callout Box -->
              <div style="background-color: #f0fdf4; border-left: 4px solid #16a34a; padding: 15px 20px; margin: 25px 0; border-radius: 0 6px 6px 0;">
                  <p style="margin: 0; font-size: 14px; color: #166534;"><strong>📎 Attached Document</strong><br>
                  Please find your official filing confirmation and tax summary attached. <strong>Please save this document</strong> in a secure place for your personal records.</p>
              </div>

              <!-- Next Steps (Helps reduce clinic support calls) -->
              <h3 style="font-size: 16px; color: #111827; margin-top: 30px; margin-bottom: 10px;">What happens next?</h3>
              <ul style="font-size: 14px; color: #4b5563; padding-left: 20px; margin-top: 0;">
                  <li style="margin-bottom: 8px;">The CRA typically processes electronically filed returns within <strong>2 weeks</strong>.</li>
                  <li>You will receive your <strong>Notice of Assessment (NOA)</strong> by mail or directly through your CRA My Account.</li>
              </ul>

              <p style="font-size: 15px; font-weight: 500; color: #111827; margin-top: 30px; margin-bottom: 0;">Thank you for trusting our CVITP clinic with your tax preparation!</p>
          </div>

          <!-- Footer -->
          <div style="background-color: #f3f4f6; padding: 30px; border-top: 1px solid #e5e7eb; font-size: 13px; color: #4b5563;">
              <strong style="font-size: 15px; color: #111827; display: block; margin-bottom: 5px;">CVITP Tax Clinic Team</strong>
              <span style="display: block; margin-bottom: 15px; color: #6b7280;">Oriental Business Solutions Inc.</span>
              
              <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 10px;">
                  <tr>
                      <td style="padding-bottom: 8px;">
                          <strong>Email:</strong> <a href="mailto:cvitp-team@orientalbiz.ca" style="color: #2563eb; text-decoration: none;">cvitp-team@orientalbiz.ca</a>
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <strong>Phone:</strong> <a href="tel:+16478475477" style="color: #2563eb; text-decoration: none;">+1 (647) 847-5477</a>
                      </td>
                  </tr>
              </table>
              
              <!-- Privacy Disclaimer -->
              <p style="margin-top: 25px; margin-bottom: 0; font-size: 11px; color: #9ca3af; line-height: 1.5;">
                  <em><strong>Privacy Note:</strong> For your security, please do not reply to this email with sensitive personal information, such as your Social Insurance Number (SIN).</em>
              </p>
          </div>

      </div>
  </div>`
  }
};
